import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BrandLogo from '../../components/common/BrandLogo';
import { MIN_PASSWORD_LENGTH } from '../../constants/password';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signIn(email, password);
      navigate('/app');
    } catch (err) {
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-base)] flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <BrandLogo size="lg" />
        </div>

        <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-3xl p-8 shadow-sm">
          <h1 className="text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tight mb-2 text-center">
            Iniciar Sesión
          </h1>
          <p className="text-xs text-[var(--text-secondary)] text-center mb-8 uppercase tracking-widest">
            Accede a la plataforma GFI Latino
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-widest mb-2">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[var(--bg-base)] border border-[var(--border-subtle)] rounded-xl py-3 px-4 text-sm text-[var(--text-main)] focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-widest">
                  Contraseña
                </label>
                <Link
                  to="/recuperar-contrasena"
                  className="text-[10px] font-bold text-brand-cyan hover:underline"
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
              <input
                type="password"
                required
                minLength={MIN_PASSWORD_LENGTH}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[var(--bg-base)] border border-[var(--border-subtle)] rounded-xl py-3 px-4 text-sm text-[var(--text-main)] focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan"
              />
            </div>

            {error && (
              <p className="text-sm text-rose-600 font-medium">{error}</p>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full gfi-gradient-bg text-brand-navy py-4 rounded-xl font-black text-xs uppercase tracking-widest transition-all hover:scale-[1.02] disabled:opacity-60"
            >
              {submitting ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <p className="text-center text-xs text-[var(--text-secondary)] mt-8">
            ¿No tienes cuenta?{' '}
            <Link to="/registro" className="text-brand-cyan font-bold hover:underline">
              Regístrate
            </Link>
          </p>
        </div>

        <button
          onClick={() => navigate('/')}
          className="w-full mt-6 text-[10px] font-bold text-[var(--text-secondary)] uppercase tracking-widest hover:text-[var(--text-main)]"
        >
          ← Volver al inicio
        </button>
      </div>
    </div>
  );
}
